import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

//Components
import Form from './Form.constants';

// Actions de Redux
import { createDrawer } from '../../redux/drawers/thunks';
import useScan from '../../hooks/useScan';

const NewDrawers = () => {
  const navigate = useNavigate();
  // utilizar use dispatch y te crea una función
  const dispatch = useDispatch<any>();
  const { setDestination } = useScan();

  useEffect(() => {
    setDestination('act-a-dra', false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialValues = {
    warehouses_id: '',
    number_divisions: '',
    drawer_row: '',
    drawer_column: '',
    rack: '',
    country: process.env.REACT_APP_ENV_COUNTRY,
  };

  // cuando el usuario haga submit
  const submitNewDrawer = (values: any) => {
    // crear el nuevo drawer
    dispatch(createDrawer(values))
      .unwrap()
      .then((res: any) => {
        if (res) {
          navigate('/drawers', { replace: true });
        }
      });
  };

  return (
    <Form
      submitDrawer={submitNewDrawer}
      initialValues={initialValues}
      actionText={'GUARDAR'}
    />
  );
};

export default NewDrawers;
